<template>
  <BaseContainer>
    <v-content slot="principal">
      <div class="main-container">
        <v-container>
          <RevendaHero />

          <div id="ganhos">
            <RevendaGanhosSection class="section" />
          </div>

          <div id="simulador">
            <RevendaSimuladorSection class="section" />
          </div>

          <div id="sistema">
            <RevendaProdutoSection class="section" />
          </div>

          <BrdeLabsAwardSection class="section" />
        </v-container>
      </div><!-- /.main-container -->

      <Footer />

      <v-btn
        v-if="!hideWhatsapp"
        id="whatsapp-button"
        fab
        x-large
        color="success"
        class="whatsapp-button"
        aria-label="Falar no WhatsApp"
        @click="onWhatsappClick"
      >
        <v-icon x-large>mdi-whatsapp</v-icon>
      </v-btn>
    </v-content>
  </BaseContainer>
</template>

<script>
  import BaseContainer from '@/components/BaseContainer.vue';
  import Footer from '@/components/Footer.vue';
  import RevendaHero from '@/components/revenda/RevendaHero.vue';
  import RevendaGanhosSection from '@/components/revenda/RevendaGanhosSection.vue';
  import RevendaSimuladorSection from '@/components/revenda/RevendaSimuladorSection.vue';
  import RevendaProdutoSection from '@/components/revenda/RevendaProdutoSection.vue';
  import BrdeLabsAwardSection from '@/components/BrdeLabsAwardSection.vue';
  import { mapState } from 'vuex';
  import scrollDepthMixin from '@/utils/useScrollDepth';
  import { trackClick } from '@/utils/lpTracker';

  export default {
    name: 'Revenda',

    mixins: [scrollDepthMixin],

    components: {
      BaseContainer,
      Footer,
      RevendaHero,
      RevendaGanhosSection,
      RevendaSimuladorSection,
      RevendaProdutoSection,
      BrdeLabsAwardSection,
    },

    computed: {
      ...mapState([
        'hideWhatsapp',
      ]),
    },

    mounted() {
      this.$root.$on('ctaButtonClick', this.irParaQuiz);
    },

    beforeDestroy() {
      this.$root.$off('ctaButtonClick', this.irParaQuiz);
    },

    methods: {
      // O quiz de /whatsapp qualifica restaurante (salão, mesas, impressora); o de
      // revenda qualifica quem quer revender e abre o WhatsApp do time de revenda.
      irParaQuiz() {
        this.$router.push({ path: '/revenda/whatsapp' });
      },

      onWhatsappClick() {
        trackClick('Revenda - WhatsApp floating button');
        this.irParaQuiz();
      },
    },
  };
</script>

<style scoped lang="scss">
  .main-container {
    margin: 12px 3% 0 3%;
  }

  .whatsapp-button {
    z-index: 999;
    position: fixed;
    bottom: 30px;
    right: 30px;
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .section {
    margin-top: 72px;
    padding-top: 72px;
    border-top: 1px solid var(--card-border);

    @media (max-width: 780px) {
      margin-top: 48px;
      padding-top: 48px;
    }
  }
</style>
